import React, {useState, useEffect, useRef} from 'react';
import { getIdPlayer, removeIdPlayer, updateLastActiveTimestamp } from '../../utils/users';
import { gameRequests } from '../../request/requests';
import VideoBackground from './comps/VideoBackground';
import ShapeBg from './comps/ShapeBg';
import Des from './comps/Des';
import Question from './comps/Question';
import Stats from './comps/Stats';
import { playerRequests } from '../../request/requests';
import { useNavigate } from 'react-router-dom';

export default function Game() {

    const [questions, setQuestions] = useState([]);
    const [currentQuestion, setCurrentQuestion] = useState(null);
    const [indexQuestion, setIndexQuestion] = useState(0);
    const [score, setScore] = useState(0);
    const [road] = useState(() => randomInt(1, 3));
    const [curentCase, setCurentCase] = useState(0);
    const [stepNumber, setStepNumber] = useState(0);
    const [steps, setSteps] = useState(null);
    const [currentStep, setCurrentStep] = useState(null);
    const [currentDes, setCurrentDes] = useState(6);
    const [videoSPlay, setVideoPlay] = useState(false);
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();
    const [position_bottom, setPositionBottom] = useState(0);
    const [currentCity, setCurrentCity] = useState("paris");
    const [usedQuestions, setUsedQuestions] = useState([]);
    const [gameCompleted, setGameCompleted] = useState(false);
    const [showRankingCard, setShowRankingCard] = useState(false);
    const [fade, setFade] = useState(false);
    const [opacity, setOpacity] = useState(1);
    const [scale, setScale] = useState(1);
    const [playersToDisplay, setPlayersToDisplay] = useState([]);

    const [cardDisplay, setCardDisplay] = useState({
        show: false,
        type: "", // "city" or "bonus"
        content: "",
    });

    useEffect(() => {
        loadPlayers();
    }, [gameCompleted]);

    // Track user activity throughout the app
    useEffect(() => {
        // Set up event listeners to track user activity
        const activityEvents = ['mousedown', 'touchstart', 'keydown', 'scroll'];
        
        const handleUserActivity = () => {
            updateLastActiveTimestamp();
        };
        
        // Add event listeners
        activityEvents.forEach(event => {
            window.addEventListener(event, handleUserActivity);
        });
        
        // Clean up event listeners
        return () => {
            activityEvents.forEach(event => {
                window.removeEventListener(event, handleUserActivity);
            });
        };
    }, []);

    useEffect(() => {
        // Check if player ID exists and is valid (not expired)
        const playerId = getIdPlayer();
        if (!playerId) {
            removeIdPlayer(); // Ensure all related data is cleared
            navigate('/'); // Redirect to login/pseudo entry page
            return;
        }

        loadQuestions();
        fetch(`/assets/road${road}/road.json`).then(res => res.json()).then(data => {
            setSteps(data);
            setCurrentStep(data[0]);
        });
    }, []);

    useEffect(() => {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({ event: 'start_game' });
      }, []);      

    const loadPlayers = async () => {
        const res = await playerRequests.getPlayers();
        if(res.success){
            const sortedPlayers = res.data.sort((a, b) => b.score - a.score);
            
            // If the game is completed, also update playersToDisplay
            if (gameCompleted) {
                setPlayersToDisplay(getPlayersToDisplay(sortedPlayers, getIdPlayer()));
            }
        }
    };

    function getPlayersToDisplay(sortedPlayers, currentPlayerId) {
        // Find current player index
        const currentPlayerIndex = sortedPlayers.findIndex(player => player.id === currentPlayerId);
        
        // Calculate start and end indexes for the 5-player window
        let startIndex = Math.max(0, currentPlayerIndex - 2);
        let endIndex = startIndex + 4;
        
        // Handle special cases
        if (currentPlayerIndex === 0) {
          // Player is 1st, show them and 4 below
          startIndex = 0;
          endIndex = Math.min(sortedPlayers.length - 1, 4);
        } else if (currentPlayerIndex === 1) {
          // Player is 2nd, show 1 above and 3 below
          startIndex = 0;
          endIndex = Math.min(sortedPlayers.length - 1, 4);
        } else if (endIndex >= sortedPlayers.length) {
          // Near bottom, adjust window to show 5 or fewer players
          endIndex = sortedPlayers.length - 1;
          startIndex = Math.max(0, endIndex - 4);
        }
        
        // Return the selected players
        return sortedPlayers.slice(startIndex, endIndex + 1).map(player => ({
            ...player,
            globalRank: sortedPlayers.findIndex(p => p.id === player.id) + 1
        }));
    }

    const loadQuestions = async () => {
        const res = await gameRequests.getQuestions();
        if(res.success){
            setQuestions(shuffleArray(res.data));
        }else{
            alert(res.msg);
        }
    }

    const next = async () => {
        updateLastActiveTimestamp();
        const nextStepIndex = stepNumber + 1;

        if (nextStepIndex >= steps.length) {
            console.warn("Aucune étape suivante disponible.");
            const player = await playerRequests.updatePlayer({id: getIdPlayer(), score: score});
            if (player.success) {
                setGameCompleted(true);
                window.dataLayer = window.dataLayer || [];
                window.dataLayer.push({ event: 'end_game' });

                setFade(true);
                setTimeout(() => {
                    setOpacity(0);
                    setScale(1.5);
                }, 100);
                loadPlayers();

            } else {
                alert(player.msg);
            }
            return;
        }
    
        const nextStep = steps[nextStepIndex];
    
        if (!nextStep) {
            console.warn("Étape suivante introuvable.");
            return;
        }
    
        console.log(`Passage à l'étape suivante: ${nextStepIndex}, Type: ${nextStep.type}, Step: ${nextStep.step}`);
    
        setLoading(true);
    
        setCurrentStep(nextStep);
        setStepNumber(nextStepIndex);
        setCurentCase(nextStep.step || 0);
    


        // Handle city or bonus card display
        if (nextStep.city) {
            setCurrentCity(nextStep.city);
            setCardDisplay({
                show: true,
                type: "city",
                content: nextStep.city
            });

            // Hide the card after 2 seconds
            setTimeout(() => {
                setCardDisplay(prev => ({...prev, show: false}));
                if (nextStep.type === "launch") {
                    setPositionBottom(0);
                    setTimeout(() => {
                        setLoading(false);
                    }, 1000);
                }
            }, 2000);

        } else if (nextStep.bonus) {
            setCardDisplay({
                show: true,
                type: "bonus",
                content: nextStep.bonus
            });
            
            // Hide the card after 2 seconds
            setTimeout(() => {
                setCardDisplay(prev => ({...prev, show: false}));
                if (nextStep.type === "launch") {
                    setPositionBottom(0);
                    setTimeout(() => {
                        setLoading(false);
                    }, 1000);
                }
            }, 2500);

        } else if (nextStep.malus) {
            setCardDisplay({
                show: true,
                type: "malus",
                content: nextStep.malus
            });
            
            // Hide the card after 2 seconds
            setTimeout(() => {
                setCardDisplay(prev => ({...prev, show: false}));
                if (nextStep.type === "launch") {
                    setPositionBottom(0);
                    setTimeout(() => {
                        setLoading(false);
                    }, 1000);
                }
            }, 2000);
        }

        if (nextStep.type === "question") {
            const audio = new Audio('./assets/sounds/popup.mp3');
            audio.play();
            
            // Get the city value directly from nextStep
            const currentCityValue = nextStep.city || currentCity;
            
            const cityQuestions = questions.filter(q => 
                (q.city || '').toLowerCase() === (currentCityValue || '').toLowerCase() && 
                !usedQuestions.includes(q.id)
            );
            
            let selectedQuestion;
            if (cityQuestions.length > 0) {
                // Get a random question for this city that hasn't been used
                const randomIndex = Math.floor(Math.random() * cityQuestions.length);
                selectedQuestion = cityQuestions[randomIndex];
                
                // Add this question to the used questions list
                setUsedQuestions(prev => [...prev, selectedQuestion.id]);
            } else {
                // All city questions used or none available - use a fallback question
                selectedQuestion = questions[indexQuestion];
                
                // Optionally track used fallback questions too
                setUsedQuestions(prev => [...prev, selectedQuestion.id]);
            }
            
            // Set the selected question
            setCurrentQuestion(selectedQuestion);
            
            // Always increment the question number counter for display purposes
            setIndexQuestion(indexQuestion + 1);
            
            setLoading(true);
            return;
        }
    
        if (nextStep.type === "next") {
            if (nextStep.src) {
                setVideoPlay(true);
                setTimeout(() => {
                    setLoading(false);
                }, 1000);
            }
        }
    
        if (nextStep.type === "launch") {
            if (!nextStep.city && !nextStep.bonus && !nextStep.malus) {
                setPositionBottom(0);
                setTimeout(() => {
                    setLoading(false);
                }, 1000);
            }
        } else {
            setPositionBottom(-100);
        }
    };
    

    const launch = () => {
        updateLastActiveTimestamp();
        // Don't proceed if the current step is a question
        if (currentStep.type === "question") {
            return;
        }
        // Check if we've already reached the end
        if (stepNumber >= steps.length) {
            console.log("Already at the last step, no dice roll.");
            return;
        }

        const des = currentStep.des;
        setCurrentDes(des);
        
        setTimeout(() => {
            setVideoPlay(true);
        }, 3200);
        
        const nextStepIndex = stepNumber + 1;
        if (nextStepIndex < steps.length)
        {
            if (steps[nextStepIndex].type !== "launch") {
                setTimeout(() => {
                    if (steps[nextStepIndex].type !== "question") {
                        next();
                    }
                }, 5100);
            } else {
                setTimeout(()=>{
                    setLoading(false);
                    setPositionBottom(0);
                }, 5750);
            }
        }
        
    };

    if(!steps){
        return <div style={{height: '100%', width: '100%', backgroundColor: 'black', position: 'fixed'}}></div>
    }

    return(
        <div style={{position: 'fixed', width: '100%', height: '100%'}}>
            <VideoBackground next={next} setVideoPlay={setVideoPlay} autoPlay={videoSPlay && !cardDisplay.show} src={currentStep.src} nextSrc={stepNumber + 1 < steps.length ? steps[stepNumber + 1].src : null} road={road}/>
            {gameCompleted && (
            <>
                {showRankingCard ? (
                    <>
                    <div className="question-container" style={{
                        position: 'fixed',
                        width: '100%',
                        height: '100%',
                        left: '0',
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        zIndex: 100
                        }}>
                        {/* Question card with mobile-optimized sizing */}
                        <div className="question-card" style={{
                            transition: 'transform 250ms ease-in-out', // Smooth animation for all properties
                            transform: `scale(1.05)`, // Slight grow effect
                            transformOrigin: 'center',
                            color: '#004A7C',
                            width: '85%',  // Slight width increase when displaying the question
                            maxWidth: '400px', // Max width adjustment
                            height: '80%', // Smaller height for intro
                            maxHeight: '600px', // Adjust max height dynamically
                            backgroundColor: '#EFF3F8',
                            borderRadius: '1em',
                            boxShadow: '8px 10px 12px rgba(0,0,0,0.4)', // Slightly smaller shadow
                            display: 'flex',
                            flexDirection: 'column',
                            overflow: 'hidden',
                            position: 'relative'
                        }}>
                            <div className="question-title-area" style={{
                            height: '20%',       // Smaller proportion for question
                            minHeight: '50px',   // Smaller minimum height
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                            padding: '0.25rem 1.5rem',  // Smaller padding
                            marginBottom: '0.5rem',
                            marginTop:'1rem',
                            overflow: 'auto',
                            }}>
                            <h1 style={{
                                fontSize: '1rem',
                                fontWeight: "400",
                                textAlign: 'center',
                                wordBreak: 'break-word',
                                overflowWrap: 'break-word',
                                margin: 0
                            }}>
                            Your score will be forever celebrated in the hall of fame of the greatest HARIBO explorers!
                            </h1>
                            </div>
                            <div style={{ 
                            display: 'flex', 
                            flexDirection: 'column', 
                            alignItems: 'center'
                            }}> 
                            <div style={{marginTop:'0.5em', marginBottom:'0.5em', width: '90%'}}>
                                {
                                    playersToDisplay.map((player, index) => {
                                        return (
                                            <div style={{margin: '0.3em 0', }} key={index}>
                                                <div style={{background: player.id === getIdPlayer() ? '#FFEA00' : 'rgba(255,255,255,0.5)', padding: '0.2em', borderRadius: '2em'}}>
                                                    <div style={{display: 'flex', flexDirection: 'row', justifyContent: 'center', alignItems: 'center'}}>
                                                        <div style={{width: '50px', height: '30px', borderRadius: '16px', background: 'white', display: 'flex', justifyContent: 'center', alignItems: 'center', fontSize: '1em', fontWeight: 'lighter', color: 'black', padding:'0.5em', left:'10px', top:'10px', margin:'5px 0 5px 5px'}}>
                                                            {player.globalRank}
                                                        </div>
                                                        <div style={{flex: 5, textAlign: 'start', marginLeft: '0.5em', fontSize: '0.8em', fontWeight: 'lighter', color: 'black'}}>
                                                        {player.pseudo.length > 16 
                                                        ? player.pseudo.slice(0, 12) + '...' 
                                                        : player.pseudo}
                                                        </div>
                                                        <div style={{flex: 2, textAlign: 'end', marginRight: '1em', fontSize: '0.8em', marginTop: '0.4em', fontWeight: 'lighter', color: 'black'}}>
                                                            {player.score} PTS
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        );
                                    })
                                }
                            </div>
                            </div>
                            
                            <div style={{ 
                            display: 'flex', 
                            flexDirection: 'column', 
                            alignItems: 'center',
                            marginTop: 'auto'
                            }}>
                                <button
                                    onClick={() => {
                                        window.location.reload()
                                    }}
                                    style={{
                                    boxShadow: '5px 8px 15px rgba(0,0,0,0.2)',
                                    textAlign: "center",
                                    color: 'white',
                                    backgroundColor: '#0C7789',
                                    borderRadius: '2em',
                                    padding: '0.5rem 1.5rem',
                                    marginBottom:'0.8rem',
                                    border: 'none',
                                    width: '80%',
                                    cursor: "pointer",
                                    textTransform:'uppercase'
                                    }}
                                >
                                    Play again
                                </button>
                                <button
                                    onClick={() => navigate('/ranking')}
                                    style={{
                                        position: 'relative',
                                        fontFamily: 'VAG Rundschrift D',
                                        fontWeight: 300,
                                        fontSize: '13px',
                                        textAlign: 'center',
                                        textDecoration: 'underline',
                                        color: '#004A7C',
                                        background: 'none',
                                        border: 'none',
                                        display: 'block',
                                        marginBottom: '2rem',
                                        cursor: 'pointer',
                                        padding: 0
                                    }}
                                >
                                    View the complete ranking
                                </button>
                            </div>
                        </div>
                    </div>
                    </>
                    ) : (
                    <>
                        <div style={{
                            position: 'fixed',
                            width: '100%',
                            height: '100%',
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center',
                            zIndex: 1000
                        }}>
                            <div style={{
                                    position: 'relative',
                                    display: 'flex',
                                    justifyContent: 'center',
                                    alignItems: 'center',
                                    marginBottom: '10px',
                                    color: '#fff',
                                    fontSize: '2.5rem',
                                    background: 'linear-gradient(180deg,rgb(41, 133, 147),rgba(45, 180, 195, 0))',
                                    width:'100%',
                                    padding: '50px 30px',
                                    overflow: 'hidden'
                                }}>

                                {/* Content - needs to be positioned above the blur */}
                                <div style={{ position: 'relative', zIndex: 1 }}>
                                    Great job!
                                </div>
                            </div>
                            <div style={{
                                width: '200px',
                                height: '200px',
                                borderRadius: '50%',
                                backgroundColor: '#FFE500',
                                display: 'flex',
                                justifyContent: 'center',
                                alignItems: 'center',
                                boxShadow: '0px 0px 20px rgba(255,204,0,0.6)',
                                border: '0.5rem solid #fff',
                                marginBottom: '30px',
                            }}>
                                <div style={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                    alignItems: 'center'
                                }}>
                                    <h1 style={{
                                        margin: '10px 0',
                                        fontSize: '35px',
                                        color: '#298593',
                                        fontWeight: '400'
                                    }}>{score} PTS</h1>
                                </div>
                            </div>
                        </div>
                        <div
                            onClick={() => {
                                setShowRankingCard(true);
                                const rest = loadPlayers();
                                console.log(rest.success);
                                
                            }}
                            style={{
                                boxShadow: '12px 14px 16px rgba(0,0,0,0.4)',
                                textAlign: "center",
                                color: '#004A7C',
                                backgroundColor: 'white',
                                borderRadius: '2em',
                                bottom: '3%',
                                padding: '8px',
                                width: '80%',
                                position: 'fixed',
                                left: '10%',
                                cursor: "pointer",
                                textTransform: "uppercase",
                                zIndex:"20000"
                            }}
                        >
                            View ranking
                        </div>
                        <ShapeBg position_bottom={-10}/>
                        {fade &&
                            <div style={{transformOrigin: 'center', scale: scale, transitionDuration: '500ms', opacity: opacity, top: 0, left: 0, margin: 0, height: '100vh', width: '100vw', position: 'fixed', zIndex: 15000, background: 'url("./assets/fade2.png")', backgroundSize: '100%'}}>
                            </div>
                        }
                    </>
                )}
            </>
        )}

            {!gameCompleted &&(
            <>
            <Stats score={score} space={curentCase}/>
            {!cardDisplay.show && (
                <ShapeBg position_bottom={position_bottom}/>
            )}
            {/* City / Bonus / Malus card (blocking, centered). */}
            {cardDisplay.show && (
                <div className="card-container" style={{
                    position: 'fixed',
                    width: '100%',
                    height: '100%',
                    left: '0',
                    top: '5%',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    zIndex: 100
                }}>
                    <div className={`${cardDisplay.type}-card`} style={{
                        transformOrigin: 'center',
                        color: '#004A7C',
                        width: '70%',
                        maxWidth: '380px',
                        height: '50%',
                        maxHeight: '400px',
                        backgroundColor: '#EFF3F8',
                        borderRadius: '1em',
                        boxShadow: '8px 10px 12px rgba(0,0,0,0.4)',
                        display: 'flex',
                        flexDirection: 'column',
                        overflow: 'hidden',
                        position: 'relative'
                    }}>
                        <div className={`${cardDisplay.type}-intro`} style={{
                            transitionDuration: '250ms',
                            textAlign: 'center',
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center',
                            height: '100%',
                            padding: '0 5%',
                            top: "0"
                        }}>
                            <img 
                                style={{ 
                                    height: '45%', 
                                    maxHeight: '50%', 
                                    objectFit: 'contain',
                                    marginTop: '1rem'
                                }} 
                                src={cardDisplay.type === "city" 
                                    ? `./assets/${cardDisplay.content}.png`
                                    : cardDisplay.type === "bonus" 
                                    ? `./assets/bonus.png`
                                    : `./assets/malus.png`
                                }
                                alt={`${cardDisplay.type === "city" ? "City" : cardDisplay.type === "bonus" ?"Bonus" : "Malus"} Logo`} 
                            />
                            <h1 style={{ 
                                marginButtom: '0.5rem',
                                fontSize: '1.4rem'
                            }}>
                                {cardDisplay.type === "city" 
                                    ? `WELCOME TO ${cardDisplay.content.toUpperCase()}!`
                                    : cardDisplay.type === "bonus"
                                    ?`${cardDisplay.content.toUpperCase()}!`
                                    : 'OH NO!'
                                }
                            </h1>
                            <p style={{ 
                                textAlign: 'center', 
                                padding: '0 5%', 
                                margin: '0.5rem 0',
                                fontSize: '1rem'
                            }}>
                                {(() => {
                                    if (cardDisplay.type === "city") {
                                        switch (cardDisplay.content.toLowerCase()) {
                                            case 'paris':
                                                return 'Start your adventure beneath the Eiffel Tower.';
                                            case 'budapest':
                                                return 'The Pearl of the Danube.';
                                            case 'rome':
                                                return 'Welcome to Rome, the Eternal City. Can you uncover its ancient mysteries?';
                                            case 'barcelona':
                                                return 'Experience the vibrant culture and architecture of Barcelona!';
                                            case 'oslo':
                                                return 'Discover the charm of Oslo, the capital of Norway!';
                                            case 'lisbon':
                                                return 'Bem-vindo a Lisboa! The city of seven hills welcomes you.';
                                            case 'amsterdam':
                                                return 'Explore the picturesque canals and vibrant culture of Amsterdam!';
                                            case 'athens':
                                                return 'Step back in time and explore the ancient wonders of Athens!';
                                            case 'london':
                                                return 'Welcome to London! Explore its rich history and iconic landmarks.';
                                            case 'berlin':
                                                return 'Discover Berlin, a city of history, culture, and modern vibrance!';
                                            default:
                                                return 'Welcome to a new adventure!';
                                        }
                                    } else if (cardDisplay.type === "bonus") { // bonus type
                                        switch (cardDisplay.content.toLowerCase()) {
                                            case 'great timing':
                                                return "You're at Charles de Gaulle Airport, flying directly to Space 29 in Budapest.";
                                            case 'spectacular':
                                                return "You're watching the sunset over the Acropolis. Move forward 2 spaces";
                                            case 'what a view':
                                                return "Sunrise at Park Güell. Move forward 2 spaces";
                                            case 'lucky you':
                                                return "You've reached Berlin-Tegel Airport and are flying straight to Space 47 in Lisbon.";
                                            case 'good timing':
                                                return "You catch a double-decker bus and move forward 2 spaces.";
                                            case 'good news':
                                                return "You're at Heathrow Airport, flying directly to Space 36 in Barcelona.";
                                            case 'nice':
                                                return "A smooth bike ride ahead. Move forward 3 spaces.";
                                            default:
                                                return 'You found a special bonus!';
                                        }
                                    } else if (cardDisplay.type === "malus") { // malus type
                                        return cardDisplay.content;
                                    }
                                })()}
                            </p>
                        </div>
                    </div>
                </div>
            )}
            {
                currentStep.type === "launch" && stepNumber < steps.length && !cardDisplay.show &&
                <Des setPositionBottom={setPositionBottom} position_bottom={position_bottom} setLoading={setLoading} loading={loading} launch={launch} src={`./assets/dés/${currentDes}.png`} currentDice={currentDes}/>
            }
            {
                currentStep.type === "question" && !cardDisplay.show &&
                <Question setScore={setScore} question_number={indexQuestion} question={currentQuestion} next={next}/>
            }
            </>
            )}
            <AudioLoop/>
        </div>
    );
}

function AudioLoop() {
    const audioRef = useRef(null);
    const [isActive, setIsActive] = useState(true);

    useEffect(() => {
      if (audioRef.current) {
        audioRef.current.loop = true;
        audioRef.current.volume = 0.6;

        if (isActive) {
            audioRef.current.play().catch(e => console.log("Cannot play audio:", e));
        } else {
            audioRef.current.pause();
        }
        
        // Handle different events that might indicate app is in background
        const pauseAudio = () => {
          if (audioRef.current) {
            audioRef.current.pause();
          }
        };
        
        const resumeAudio = () => {
          if (audioRef.current && document.visibilityState === 'visible') {
            audioRef.current.play().catch(e => console.log("Cannot resume audio:", e));
          }
        };
        
        // Page Visibility API
        document.addEventListener('visibilitychange', () => {
          if (document.hidden) {
            pauseAudio();
          } else {
            resumeAudio();
          }
        });
        
        // Mobile specific events
        window.addEventListener('pagehide', pauseAudio);
        window.addEventListener('pageshow', resumeAudio);
        window.addEventListener('blur', pauseAudio);
        window.addEventListener('focus', resumeAudio);
        
        // Additional mobile events
        document.addEventListener('pause', pauseAudio); // Cordova/PhoneGap specific
        document.addEventListener('resume', resumeAudio); // Cordova/PhoneGap specific

        // Add heartbeat check
        let lastTime = Date.now();
        const heartbeatInterval = setInterval(() => {
            const currentTime = Date.now();
            // If more than 10 seconds passed between checks, 
            // the phone was likely sleeping or app was in background
            if (currentTime - lastTime > 10000) {
            setIsActive(false);
            audioRef.current.pause();
            }
            lastTime = currentTime;
        }, 1000);
        
        return () => {
            clearInterval(heartbeatInterval);
            document.removeEventListener('visibilitychange', pauseAudio);
            window.removeEventListener('pagehide', pauseAudio);
            window.removeEventListener('pageshow', resumeAudio);
            window.removeEventListener('blur', pauseAudio);
            window.removeEventListener('focus', resumeAudio);
            document.removeEventListener('pause', pauseAudio);
            document.removeEventListener('resume', resumeAudio);
        };
      }
    }, [isActive]);
  
    return (
      <audio style={{display: 'none'}} ref={audioRef} controls>
        <source src="./assets/sounds/music.mp3" type="audio/mp3" />
        Votre navigateur ne supporte pas l'audio HTML5.
      </audio>
    );
}

function shuffleArray(tableau) {
    for (let i = tableau.length - 1; i > 0; i--) {
        let j = Math.floor(Math.random() * (i + 1));
        [tableau[i], tableau[j]] = [tableau[j], tableau[i]];
    }
    return tableau;
}

function randomInt(min, max) {
    return Math.floor(Math.random() * (max - min + 1) + min);
}